import Vue from 'vue'
import ApiError from '../models/api-error'
import Bus from '@/components/bus'

class ApiBase{

  static getFile(url,callBack,responseParse,errorCallBack){
    Vue.axios({
      url: url,
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      if (callBack) {
        callBack(response)
      }
    }).catch((err) => {
      ApiBase.defualtErrorCallBack(err)
      if (errorCallBack) {
        errorCallBack(err)
      }
    });
  }
  static get(url,callBack,responseParse,errorCallBack){
    Vue.axios.get(url).
    then(response => {
      if (callBack) {
        callBack(responseParse(response))
      }
    }).catch((err) => {
      ApiBase.defualtErrorCallBack(err)
      if (errorCallBack) {
        errorCallBack(err)
      }
    })
  }
  static post(url,data,callBack,responseParse,errorCallBack){
    
    Vue.axios.post(url, data, { headers: { 'Access-Control-Allow-Origin': '*' } } ).
    then(response => {
      if (callBack) {
        callBack(responseParse(response))
      }
    }).catch((err) => {
      ApiBase.defualtErrorCallBack(err)
      if (errorCallBack) {
        errorCallBack(err)
      }
    })
  }
  static put(url,data,callBack,responseParse,errorCallBack){
  //  data._method = "PUT";
    Vue.axios.put(url, data, { headers: { 'Access-Control-Allow-Origin': '*' } } ).
    then(response => {
      if (callBack) {
        callBack(responseParse(response))
      }
    }).catch((err) => {
      ApiBase.defualtErrorCallBack(err)
      if (errorCallBack) {
        errorCallBack(err)
      }
    })
  }
  static patch(url,data,callBack,responseParse,errorCallBack){
  //  data._method = "PUT";
    Vue.axios.patch(url, data, { headers: { 'Access-Control-Allow-Origin': '*' } }).
    then(response => {
      if (callBack) {
        callBack(responseParse(response))
      }
    }).catch((err) => {
      ApiBase.defualtErrorCallBack(err)
      if (errorCallBack) {
        errorCallBack(err)
      }
    })
  }
  static delete(url,callBack,responseParse,errorCallBack){
    Vue.axios.delete(url).
    then(response => {
      if (callBack) {
        callBack(responseParse(response))
      }
    }).catch((err) => {
      ApiBase.defualtErrorCallBack(err)
      if (errorCallBack) {
        errorCallBack(err)
      }
    })
  }

  static defualtErrorCallBack(error){
    console.log("API ERROR", error.response)
    Bus.$emit(Bus.ACTION_SHOW_ALERT, { title: "alerts_error_title", msg: error.response ? error.response.data.message : error.message })
  }

  static noParse(response){
    return response
  }

}

export default ApiBase



// WEBPACK FOOTER //
// ./src/api/apiBase.js